import { FC } from 'react';

import { useFormikContext } from 'formik';

import { SpinBannerForm } from '../form';

import css from './SpinBannerPreview.module.css';

import { fileSrc } from 'v2/utils';

export const SpinBannerPreview: FC = () => {
  const { values } = useFormikContext<SpinBannerForm>();

  const { description, casinoButtonText, topLabelText, badgeText, logoId } = values;

  return (
    <div className={css.wrapper}>
      <p className={css.title}>Preview</p>

      <div className={css.container}>
        {topLabelText && <div className={css.topLabel}>{topLabelText}</div>}

        <div className={css.logoContainer}>
          {logoId ? (
            <img src={fileSrc(logoId)} alt="Partner logo" />
          ) : (
            <div className={css.logoPlaceholder}>Partner logo</div>
          )}
        </div>

        <div className={css.description} dangerouslySetInnerHTML={{ __html: description || '' }} />

        <div className={css.buttonContainer}>
          {badgeText && <div className={css.badge}>{badgeText}</div>}
          <div className={css.button}>{casinoButtonText || 'Button'}</div>
        </div>
      </div>
    </div>
  );
};
